module.exports = __webpack_public_path__ + "img/日本標準_03.c82b3607.png";